import axios from "axios";
import { BASE_URL_ADMIN } from "../../Config/BaseUrl";
import { appToken } from "../../utils/storageHelper";

const createAxiosConfig = (url, method, data, useAuth = true) => {
  const headers = { "Content-Type": "application/json" };
  if (useAuth) {
    const token = appToken();
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }

  return {
    method,
    url: `${BASE_URL_ADMIN}${url}/`,
    headers,
    data,
  };
};

export const AuthApis = {
  AdminLogin: async (data) => {
    const axiosConfig = createAxiosConfig("/login", "POST", data, false);
    return await axios(axiosConfig);
  },

  CreateUser: async (email, password, companyName) => {
    const axiosConfig = createAxiosConfig(
      "/add-user",
      "POST",
      {
        email,
        password,
        company_name: companyName,
      },
      true
    );
    return await axios(axiosConfig);
  },

  GetUsers: async () => {
    // Use the same createAxiosConfig helper
    const axiosConfig = createAxiosConfig("/get-users", "GET", null, true);
    return await axios(axiosConfig);
  },

  DeleteUser: async (userId) => {
    const axiosConfig = createAxiosConfig(
      `/delete-user/${userId}`,
      "DELETE",
      null,
      true
    );
    return await axios(axiosConfig);
  },

  GetSummary: async () => {
    // Use the same createAxiosConfig helper
    const axiosConfig = createAxiosConfig(
      "/all_users_assessment_summary",
      "GET",
      null,
      true
    );
    return await axios(axiosConfig);
  },

  changePasword: async (user_id, old_password, new_password) => {
    const axiosConfig = createAxiosConfig(
      "/change_password",
      "POST",
      {
        user_id: user_id || null,
        old_password,
        new_password,
      },
      true
    );
    return await axios(axiosConfig);
  },
};
